export default {
    Cilindro: ['44', '45']
}